import React from 'react';

const IconAlert = () => {
  return (
    <svg data-test="iconalert" width="22" height="20" viewBox="0 0 22 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 19.7871L11 0.787109L22 19.7871H0ZM18.53 17.7871L11 4.77711L3.47 17.7871H18.53ZM10 14.7871V16.7871H12V14.7871H10ZM10 8.78711H12V12.7871H10V8.78711Z"
        fill="#333333"
      />
    </svg>
  );
};

export default IconAlert;
